module.exports = "/fonts/TT-Norms-Pro-Regular.ttf";